import React from "react";

function IllustrationTheMultipleListingService() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 96">
      <g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
        <path
          d="M49.5 28.52a5.02 5.02 0 0110.023-.421l.25 2.974h8.453l.25-2.974a5.02 5.02 0 0110.024.421v.267a5.287 5.287 0 01-5.287 5.286h-2.229l-2.49 29.553a1.5 1.5 0 01-2.989-.252l2.469-29.3h-7.948l2.469 29.3a1.5 1.5 0 01-2.99.252l-2.49-29.553h-2.228a5.287 5.287 0 01-5.287-5.286v-.267zm7.263 2.553l-.23-2.722a2.02 2.02 0 00-4.033.17v.266a2.287 2.287 0 002.287 2.286h1.976zm14.474 0h1.976a2.287 2.287 0 002.287-2.286v-.267a2.02 2.02 0 00-4.034-.17l-.229 2.723z"
          className="fill-primary"
        />
        <path
          d="M50.673 72h26.654a2 2 0 001.81-1.148l5.768-12.26c.125-.265.278-.515.456-.746l3.96-5.117a30.85 30.85 0 005.92-24.581C92.498 13.565 79.761 3 64.923 3H62.49C47.527 3 34.764 13.834 32.334 28.6a30.562 30.562 0 005.986 23.665l4.319 5.581c.178.231.331.481.456.745l5.769 12.26A2 2 0 0050.674 72zm26.654 3a5 5 0 004.524-2.871l5.769-12.26a1 1 0 01.114-.187l3.96-5.117a33.85 33.85 0 006.495-26.971C95.18 11.591 81.205 0 64.923 0H62.49C46.058 0 32.042 11.898 29.374 28.112a33.562 33.562 0 006.573 25.99l4.32 5.58a1 1 0 01.113.187l5.769 12.26A5 5 0 0050.673 75h26.654zM48 80.5a1.5 1.5 0 011.5-1.5h28a1.5 1.5 0 010 3h-28a1.5 1.5 0 01-1.5-1.5zm0 7a1.5 1.5 0 011.5-1.5h28a1.5 1.5 0 010 3h-28a1.5 1.5 0 01-1.5-1.5zm4 7a1.5 1.5 0 011.5-1.5h20a1.5 1.5 0 010 3h-20a1.5 1.5 0 01-1.5-1.5z"
          className="fill-secondary"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path className="fill-secondary" d="M0 0h128v96H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IllustrationTheMultipleListingService;
